/* globals */

import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import {
  SUCCESS_API_CREATE_ROOM,
  SUCCESS_API_GET_ENTER_ROOM_INFO,
  SUCCESS_API_GET_NO_JOINED_ROOMS,
  SUCCESS_API_GET_ROOM_INFO,
  SUCCESS_API_UPDATE_MEMBER_STATUS,
  REMOTE_SUPPORT_READY,
  SET_REMOTE_ENABLED,
  SUCCESS_API_GET_DEVICE_DETAIL,
  ENTER_ROOM,
  LEAVE_ROOM,
  INIT_ROOM_ERROR_CODE,
  SET_STEP,
  SUCCESS_API_DELETE_ROOM,
  RECEIVED_ROOM_INCOMING_INFO,
  RECEIVED_ROOM_OUTGOING_INFO,
} from '../actions/actionTypes';
import config from '../config';
import {
  PAGE_PATH,
  REMOTE_MEMBER_STATUS,
  REMOTE_COMMAND,
  TLVX_RECEIVE_COMMANDS,
} from '../lib/constants';
import { sendDataJoinedMembers } from '../lib/remote';
import { loadSessionStorage, notifyRemoteCall } from '../lib/tools';
import messages from '../lib/i18n';

dayjs.extend(isSameOrAfter);
const sessionStorageKey = config.sessionStorageKey.remote;
const { locale } = config;
const i18nMessages = messages[locale];

const appInitialState = {
  sfTabVisible: true,
  initiateAt: undefined,
  myOperatorId: 0,
  isRemote: false,
  roomEntranceInfo: {},
  canEnterRoom: true,
  remoteSupportReady: false,
  device: {},
  callingRooms: [],
  callingRoomsMembers: [],
  roomMembers: [],
  resetRequest: false,
  errorCode: '',
  step: 0,
  roomDeleted: false,
  incomingParticipantIds: [],
  outgoingParticipantIds: [],
  oppositeOperatorIds: [],
  oppositeDeviceId: 0,
  blackboardId: 0,
  favoriteId: 0,
  incomingAlertTarget: {},
  currentSharer: {}, // 現在映像共有している人
  noticedAppRoomId: 0,
  calledGetRoomInfo: false,
};

const getCurrentSharer = (roomMembers, participantId) =>
  roomMembers.find(member => member.participantId === participantId) || {};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'SET_SF_TAB_VISIBLE': {
      const { sfTabVisible } = action;
      return { ...state, sfTabVisible };
    }
    case 'SUCCESS_API_GET_USER_INFO': {
      const userInfo = action.payload;
      const { operatorId: myOperatorId } = userInfo;
      return { ...state, myOperatorId };
    }
    /** 発信側ルーム入室情報取得 */
    case SUCCESS_API_CREATE_ROOM: {
      const info = action.payload || null;
      const roomEntranceInfo = (info && info.roomEntranceInfo) || {};
      const apiErrorCode = (info && info.errorCode) || '';
      const apiResult = (info && info.result) || false;
      const errorCode = (!apiResult && apiErrorCode) || '';
      return { ...state, roomEntranceInfo, canEnterRoom: true, errorCode };
    }
    /** 着信側ルーム入室情報取得 */
    case SUCCESS_API_GET_ENTER_ROOM_INFO: {
      const info = action.payload || null;
      const roomEntranceInfo = (info && info.roomEntranceInfo) || {};
      const apiErrorCode = (info && info.errorCode) || '';
      const apiResult = (info && info.result) || false;
      const errorCode = (!apiResult && apiErrorCode) || '';
      return {
        ...state,
        roomEntranceInfo,
        canEnterRoom: true,
        errorCode,
      };
    }
    /** 未入室ルーム取得処理 */
    case SUCCESS_API_GET_NO_JOINED_ROOMS: {
      const callingRooms =
        (action.payload.result && action.payload.rooms) || [];
      const callingRoomsMembers = state.callingRoomsMembers.filter(room =>
        callingRooms.some(target => target.appRoomId === room.appRoomId),
      );
      const { initiateAt } = state;
      const incomingAlertTarget = callingRooms.find(room => {
        const res =
          dayjs(room.calledAt).isSameOrAfter(initiateAt) &&
          state.myOperatorId !== room.caller.operatorId &&
          room.status === REMOTE_MEMBER_STATUS.wait;
        return res;
      });
      // 通知処理
      if (incomingAlertTarget) {
        const { appRoomId, caller } = incomingAlertTarget;
        const { noticedAppRoomId = 0 } = state;
        if (noticedAppRoomId !== appRoomId) {
          const title =
            (caller.name &&
              i18nMessages['remote.incoming.alert.message'].replace(
                '{name}',
                caller.name,
              )) ||
            i18nMessages['remote.incoming.alert.message.nameUnknown'];
          const link = `${PAGE_PATH.DS_REMOTE}/pre/${REMOTE_COMMAND.answer}?appRoomId=${appRoomId}`;
          const params = { title, tag: 'remoteCall', link };
          notifyRemoteCall(params);
        }
      }
      return {
        ...state,
        callingRooms,
        callingRoomsMembers,
        incomingAlertTarget: incomingAlertTarget || {},
        noticedAppRoomId:
          (incomingAlertTarget && incomingAlertTarget.appRoomId) ||
          state.noticedAppRoomId,
      };
    }
    /** 入室済みのルーム情報取得後処理 */
    case SUCCESS_API_GET_ROOM_INFO: {
      const info = action.payload || null;
      const apiErrorCode = (info && info.errorCode) || '';
      const apiResult = (info && info.result) || false;
      const errorCode = (!apiResult && apiErrorCode) || '';
      const roomMembers = (apiResult && action.payload.roomMembers) || [];
      const calledGetRoomInfo = true;
      return { ...state, roomMembers, errorCode, calledGetRoomInfo };
    }
    /** 未入室ルームのメンバー情報取得後処理 */
    case 'SUCCESS_API_GET_CALLING_ROOM_MEMBERS': {
      const { appRoomId, roomMembers } = action.payload;
      if (!appRoomId) {
        return state;
      }

      const callingRoomsMembers = state.callingRoomsMembers.slice();
      const index = callingRoomsMembers.findIndex(
        item => item.appRoomId === appRoomId,
      );
      if (index > -1) {
        callingRoomsMembers.splice(index, { appRoomId, roomMembers });
      } else {
        callingRoomsMembers.push({ appRoomId, roomMembers });
      }
      return { ...state, callingRoomsMembers };
    }
    /** 未入室ルーム表示ダイアログクローズ処理 */
    case 'RESET_CALLING_ROOMS_INFO': {
      return { ...state, callingRoomsMembers: [] };
    }
    /** 再コール処理 */
    case 'SUCCESS_API_RECALL_ROOM_MEMBER': {
      const info = action.payload || null;
      const apiErrorCode = (info && info.errorCode) || '';
      const apiResult = (info && info.result) || false;
      const errorCode = (!apiResult && apiErrorCode) || '';
      return { ...state, errorCode };
    }
    case SUCCESS_API_UPDATE_MEMBER_STATUS: {
      const info = action.payload || null;
      const apiErrorCode = (info && info.errorCode) || '';
      const apiResult = (info && info.result) || false;
      const errorCode = (!apiResult && apiErrorCode) || '';
      return { ...state, resetRequest: false, errorCode };
    }
    case REMOTE_SUPPORT_READY: {
      const { result } = action;
      return { ...state, remoteSupportReady: result, resetRequest: !result };
    }
    case SET_REMOTE_ENABLED: {
      return { ...state, isRemote: true };
    }
    case SUCCESS_API_GET_DEVICE_DETAIL: {
      const device = action.payload;
      const deviceNickname = (device && device.deviceNickname) || '';
      const cutLen = 105;
      const deviceDisplayName =
        deviceNickname.length > cutLen
          ? `${deviceNickname.substr(0, cutLen)}...`
          : deviceNickname;
      return { ...state, device: { ...device, deviceDisplayName } };
    }
    case ENTER_ROOM: {
      return { ...state, canEnterRoom: false };
    }
    case LEAVE_ROOM: {
      const roomEntranceInfo = {};
      return { ...state, roomEntranceInfo };
    }
    case INIT_ROOM_ERROR_CODE: {
      const { errorCode } = appInitialState;
      return { ...state, errorCode };
    }
    case SET_STEP: {
      const step = action.step || 0;
      return {
        ...state,
        step,
        calledGetRoomInfo: action.step === 1 ? false : state.calledGetRoomInfo,
      };
    }
    case SUCCESS_API_DELETE_ROOM: {
      const roomDeleted = true;
      return { ...state, roomDeleted };
    }
    case RECEIVED_ROOM_INCOMING_INFO: {
      const { participantId } = action;

      if (participantId) {
        const incomingParticipantIds = state.incomingParticipantIds.slice();
        incomingParticipantIds.push(participantId);
        const outgoingParticipantIds = state.outgoingParticipantIds.filter(
          memberId => memberId !== participantId,
        );
        return { ...state, incomingParticipantIds, outgoingParticipantIds };
      }
      return state;
    }
    case RECEIVED_ROOM_OUTGOING_INFO: {
      const { participantId } = action;
      if (participantId) {
        const outgoingParticipantIds = state.outgoingParticipantIds.slice();
        outgoingParticipantIds.push(participantId);
        const incomingParticipantIds = state.incomingParticipantIds.filter(
          memberId => memberId !== participantId,
        );
        return { ...state, incomingParticipantIds, outgoingParticipantIds };
      }
      return state;
    }
    /** 発信または着信時にLocalstorageから取得した情報を保存する処理 */
    case 'SET_REMOTE_INFO': {
      const {
        oppositeOperatorIds = [],
        oppositeDeviceId = 0,
        blackboardId = 0,
        favoriteId = 0,
        appRoomId = 0,
      } = action;
      const { roomEntranceInfo } = state;
      return {
        ...state,
        oppositeOperatorIds,
        oppositeDeviceId,
        blackboardId,
        favoriteId,
        roomEntranceInfo: appRoomId
          ? { ...roomEntranceInfo, appRoomId }
          : roomEntranceInfo,
      };
    }
    // ローカルストレージ読み込み
    case 'LOAD_SEARCH_CRITERIA': {
      const initiateAt = dayjs();
      const strOppositeOperatorIds = loadSessionStorage(
        sessionStorageKey.oppositeOperatorIds,
      );
      const strOppositeDeviceId = loadSessionStorage(
        sessionStorageKey.oppositeDeviceId,
      );
      const strBlackboardId = loadSessionStorage(
        sessionStorageKey.blackboardId,
      );
      const strFavoriteId = loadSessionStorage(sessionStorageKey.favoriteId);
      const strAppRoomId = loadSessionStorage(sessionStorageKey.appRoomId);
      const oppositeOperatorIds =
        (strOppositeOperatorIds && JSON.parse(strOppositeOperatorIds)) || [];
      return {
        ...state,
        initiateAt,
        oppositeOperatorIds,
        oppositeDeviceId: Number(strOppositeDeviceId),
        blackboardId: Number(strBlackboardId),
        strFavoriteId: Number(strFavoriteId),
        roomEntranceInfo: strAppRoomId
          ? { appRoomId: Number(strAppRoomId) }
          : state.roomEntranceInfo,
      };
    }
    // 着信を拒否
    case 'REJECT_REMOTE_INCOMING': {
      const initiateAt = dayjs();
      return { ...state, incomingAlertTarget: {}, initiateAt };
    }
    // 着信に応答
    case 'ANSWER_REMOTE_INCOMING': {
      const initiateAt = dayjs();
      return { ...state, incomingAlertTarget: {}, initiateAt };
    }
    // 着信に未応答
    case 'NOTANSWER_REMOTE_INCOMING': {
      const initiateAt = dayjs();
      return { ...state, incomingAlertTarget: {}, initiateAt };
    }
    // アプリユーザの映像共有ボタン押下処理
    case 'SHARE_REMOTE_CAMERA': {
      const { participantId } = action;
      // 映像共有者をTLVXで送信する
      sendDataJoinedMembers(TLVX_RECEIVE_COMMANDS.changeSharer, participantId);
      return { ...state };
    }
    case 'RECEIVED_CHANGE_VIDEO_SHARER': {
      const { participantId } = action;
      const currentSharer = getCurrentSharer(state.roomMembers, participantId);
      return { ...state, currentSharer };
    }
    // 映像共有者クリアコマンド受診
    case 'RECEIVED_CLEAR_VIDEO_SHARER': {
      return { ...state, currentSharer: appInitialState.currentSharer };
    }
    default:
      return state;
  }
};
